<script lang="ts">
  import * as Sidebar from "$lib/components/ui/sidebar/index.js";
</script>

<Sidebar.Inset>
  <header class="flex h-16 items-center gap-2 border-b border-border px-4">
    <Sidebar.Trigger class="md:hidden" />
    <h2 class="text-lg font-semibold">Hangfire</h2>
  </header>
  <section class="flex h-[calc(100svh-4rem)] flex-col">
    <iframe
      class="h-full w-full border-0"
      src="/hangfire"
      title="Hangfire Dashboard"
    ></iframe>
  </section>
</Sidebar.Inset>
